<template>
  <div class="mg-b-20">
      <!-- <ol class="list-group">
          <ui v-for="(d,i) in discussions" :key="i" class="list-group-item">
              {{i+1}}.) {{d.task}}
          </ui>
      </ol> -->

    <div v-if="(mode == 2 || mode==3) && taskObj.rdy" class="btn btn-primary btn-uppercase btn-xs pos-absolute r-20 t-5">
        <a @click="mode=1">Буцах</a>        
    </div>

    <forum-list v-if="mode==1" :b="{nm:'Хэлэлцүүлэг'}" :tasks="discussions" @on-detail="init($event, 2)" />
            <!--  -->
    <div v-else-if="mode == 2 && taskObj.rdy">
        <forum-topic  :task="taskObj.task" @on-detail="init($event, 3)" />
    </div>
    <div v-else-if="mode==3 && taskObj.rdy">
        <forum-reply :id="taskObj.task.id" @on-attach="onAttach" ></forum-reply>
    </div>

    <div class="divider-text">Сургалтын тухай</div>
    
    <file-sidebar
      :id.sync="fileSidebar.id"
      :show="fileSidebar.show"
      @on-hide="
        fileSidebar.show = false;
        fileSidebar.id = 0;
      "
    />
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";

export default {
    components: {
        forumList: () => ({
            component: import("@/views/modules/lms/student/sections/forumList.vue"),
            loading: AsyncLoading,
            error: AsyncLoadError,
            delay: 100,
            timeout: 5000
        }),
        forumTopic: () => ({
            component: import("@/views/modules/lms/student/sections/forumTopic.vue"),
            loading: AsyncLoading,
            error: AsyncLoadError,
            delay: 100,
            timeout: 5000
        }),
        forumReply: () => ({
            component: import("@/views/modules/lms/student/sections/forumReply.vue"),
            loading: AsyncLoading,
            error: AsyncLoadError,
            delay: 100,
            timeout: 5000
        }),
        fileSidebar: () => ({
            component: import("@/components/modules/media/preview.vue"),
            loading: AsyncLoading,
            error: AsyncLoadError,
            delay: 100,
            timeout: 5000
        }),
    },
    props:{
      discussions: {
        type: Array,
        default: () => []
      },
    },
    data(){
        return{
            curTaskId: null,
            curTaskLoaded:false,
            mode: 1,
            taskObj:{
                rdy: false,
                task: {}
            },
            fileSidebar: {
                show: false,
                id: 0
            },
        }
    },
    mounted() {
        // if(this.discussions.length){
        //     this.init(this.discussions[0]['id']);
        // }
    },
    methods:{
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body;
            if (addRemoveClass === "addClass") {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        },
        init(e, mode) {
            this.taskObj.rdy = false;
            
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
                api: { method: "GET", url: "task/taskInheritedDetail" },
                params: { id: e.id },
                store: this.$store
            }).then(res => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                    this.taskObj.task = res.data.task;
                    this.taskObj.rdy = true;
                    this.mode= mode;
                }
            });
        },
        onAttach(e){
            this.fileSidebar.id = parseInt(e, 10);
            this.fileSidebar.show = true;
        }
    }
}
</script>

<style>

</style>